/*
 * コンサルタント案件メンバー（api create）
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CAN_CREATE_PROFESSIONAL_RFP_MEMBER = 'API_CAN_CREATE_PROFESSIONAL_RFP_MEMBER';
export const API_CREATE_PROFESSIONAL_RFP_MEMBER = 'API_CREATE_PROFESSIONAL_RFP_MEMBER';
/**
 * 案件にメンバーを追加できるかどうか判定する際のAPI
 * @param data
 * @param meta
 * @returns
 */
export const apiCanCreateProfessionalRfpMember = ({ json, path: { id } }, meta) => apiCreate(API_CAN_CREATE_PROFESSIONAL_RFP_MEMBER, `/professional/rfp/${id}/can_add_member`, json, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id } }));
/**
 * 案件にメンバーを追加する際のAPI
 * @param data
 * @param meta
 * @returns
 */
export const apiCreateProfessionalRfpMember = ({ json, path: { id } }, meta) => apiCreate(API_CREATE_PROFESSIONAL_RFP_MEMBER, `/professional/rfp/${id}/add_member`, json, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id } }));
